export default __webpack_public_path__ + "static/origin_img_v1-e73b7200611e0a9234ef8ed140a0da69.png";